import React from 'react';
import {backendURL} from '@/api';

const DownloadFileButton = ({path, children, useRei = false, ...rest}) => (
  <button
    type='button'
    onClick={() => {
      window.open(backendURL(path, {useRei}));
    }}
    {...rest}
  >
    {children}
  </button>
);

export default DownloadFileButton;
